/**
 * Series Page - Uses unified content page
 */
import React from "react";
import { ContentPage } from "../../components/content";

const SeriesPage = () => {
  return <ContentPage />;
};

export default SeriesPage;
